export class AuditBenchSummaryInputDTO {

    actionType: string;
    auditId: string;
    exportListName: string;
    siteId: string;
    auditProgramName: string;
    reportType: string;
    userType: string;
    isPreviewAvailable: string;
    isDraftReportReleased: string;
    isFinalReportReleased: string;

    auditProgramId: string;
    eventId: string;
    ratingId: number;
    forInformation: boolean;
    mailForCoeRegion: boolean;
    disableDraftReport: boolean;
    auditAreaId: string;
    financialYear: string;
}